import { Grid, withStyles } from '@material-ui/core'
import React, { useEffect } from 'react'
import { acGetCustomerInformation } from '../../../class/actions'
import { ROUTER } from '../../../class/constants'
import { useDispatch, connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Label } from '../../default'
import { rCNPJ, rEMAIL } from '../../../class/utils'
import { CardSearchEmailCnpj } from '../../cards'

const PanelBlock = ({ classes, customerInfo }) => {

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  const onSearch = (emailCnpj) => {
    const isEmail = emailCnpj.match(rEMAIL)
    const isCnpj = emailCnpj.match(rCNPJ)

    if(!isEmail && !isCnpj) {
      return
    }

    return history.push({
      pathname: isEmail ? ROUTER.BLOCK_SEARCH.EMAIL : ROUTER.BLOCK_SEARCH.CNPJ,
      state: {
        data: emailCnpj
      }
    })
  }

  useEffect(() => {
    dispatch(acGetCustomerInformation())
      .catch(err => console.error(err))
  }, [dispatch])

  return (
    <Grid container spacing={3} className={classes.root}>
      {
        customerInfo ? (
          <Grid item xs={12}>
            <Label v='h5' bold>{t('panels.customer.title')}</Label>
          </Grid>
        ) : null
      }
      <Grid item xs={12}>
        <CardSearchEmailCnpj title={t('cards.block.title')} caption={t('cards.block.caption')} onSearch={onSearch}/>
      </Grid>
    </Grid>
  )
}


const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

const mapStateToProps = ({ ReducerCustomer }) => ({
  customerInfo: ReducerCustomer.customerInfo
})

export default connect(mapStateToProps)(withStyles(styles)(PanelBlock))